module.exports = __webpack_public_path__ + "img/CB3-L1-B.5a388c89.gif";